// extracted by mini-css-extract-plugin
export default {"container":"stats-card_container__umQSp","title":"stats-card_title__qV48k","value":"stats-card_value__mwxVA"};